
module.exports = {"attributes":{"width":"31","height":"40"},"content":"<path d=\"M31 19c0 14.7-7.9 21-18.6 21C8 40 4 38.8 2.2 37.4v-1.1c1.8 1 4 1.3 6.5 1.3 7.8 0 11-5.3 11.6-16.2a14 14 0 0 1-9.6 4C3.7 25.5 0 20.2 0 13.2 0 5.7 5 0 15 0c11 0 16 7.7 16 19zm-20.6-7.3c0 7 1.7 9.5 5.3 9.5 1.5 0 3.4-.3 4.7-1v-2.8C20.4 5.8 18.7 1 15 1c-3.2 0-4.5 3.1-4.5 10.6z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
